import React from "react";
import Faq from "../../FAQ/faq";
import { useNavigate } from "react-router-dom";
const SolarInverter = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <div
        className="w-full flex justify-center items-center text-white font-bold px-4 bg-cover bg-center min-h-[220px] md:min-h-[280px] py-10 md:py-16"
        style={{
          backgroundImage: `url(/banner.png)`,
        }}
      >
        <div className="text-center  max-w-[95%] sm:max-w-[80%] md:max-w-[60%] px-2">
          {/* Heading */}
          <h1 className="text-brand-green text-2xl sm:text-3xl md:text-7xl leading-snug sm:leading-normal">
            Reliable Energy Conversion with Smart Inverter Technology
          </h1>
          {/* Paragraph */}
          <p className="text-sm sm:text-base md:text-lg mt-4 text-black leading-relaxed">
            At Kyra Green Energy Solution, We Offer A Wide Range Of High-Efficiency Inverters Designed To Convert Solar Power Into Usable Electricity For Your Home Or Business. Whether You're Looking For On-Grid, Hybrid, Or Off-Grid Inverters, Our Solutions Ensure Reliable, Consistent Energy With Advanced Technology And Industry-Leading Performance.          </p>
        </div>
      </div>

      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                Our Inverter Range
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                <strong style={{ color: "#216700" }}>OG Hybrid Inverter (1.2kW – 6.5kW)</strong><br />
                The OG Hybrid Inverter Is A Versatile Solar Inverter That Combines
                Grid Connectivity And Battery Backup To Provide Reliable Power. It’s
                Perfect For Both Residential And Commercial Applications That Need
                Energy Independence And Security.
              </p>
              <div className="space-y-3">
                <h3 className="font-semibold" >
                  Key Features:
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Supports High-Power PV Panels (Up To 18A Input)
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Compatible With Lithium Or Lead-Acid Batteries (40–60V Range)
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Parallel Connection For Up To 9 Units
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    IP65 Rating For Use Indoors Or Outdoors
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    LCD Touch Screen For Easy Control And Remote Monitoring
                  </li>
                </ul>
              </div>

              <div className="mt-6">
                <button
                  className="px-6 py-3 text-white font-semibold rounded shadow bg-brand-green"
                  onClick={handleClick}

                >
                  Request a Quote
                </button>
              </div>
            </div>

            <div className="">
              <img
                src="/solar-ess-battery-system-with-panel.png"
                alt="OG Hybrid Inverter"
              />
            </div>
          </div>
        </div>
      </section>


      <section className="py-16 px-4 ">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                On-Grid Inverters
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Perfect For Residential And Commercial Properties That Want To Connect Directly To The Electricity Grid.
                Our On-Grid Inverters Ensure You Get Maximum Energy From The Sun While Also Sending Excess Energy Back To The Grid.
              </p>
              <div className="space-y-3">
                <h3 className="font-semibold" >
                  Key Features:
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Grid-Tied For Seamless Energy Flow
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Built-In Safety Features To Prevent Back-Feeding
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Real-Time Monitoring Via Mobile App
                  </li>
                </ul>
                <p className="mt-4 text-gray-700">
                  Best For: Homes And Businesses With Reliable Grid Connectivity.
                </p>
              </div>
            </div>
            <div>
              <img src="/compact-solar-hybrid-inverter.png" alt="On-Grid Inverter" />
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-16">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Hybrid Inverters */}
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                Hybrid Inverters
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                The Hybrid Inverters Offer The Flexibility Of Both Grid Connectivity And Battery Backup.
                This Type Of Inverter Allows You To Store Excess Energy For Use During Power Outages Or When Energy Demand Is High.
              </p>
              <div className="space-y-3">
                <h3 className="font-semibold" >
                  Key Features:
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Dual Functionality (Grid-Tied And Backup Support)
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Compatible With Most Energy Storage Systems (ESS)
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Advanced Control Systems For Maximum Energy Optimization
                  </li>
                </ul>
                <p className="mt-4 text-gray-700">
                  Best For: Homeowners Or Businesses Looking For Energy Independence And Backup Power.
                </p>
              </div>
            </div>

            {/* Off-Grid Inverters */}
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                Off-Grid Inverters
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                For Those Seeking Complete Independence From The Grid, Our Off-Grid Inverters Are Perfect.
                They Provide Reliable Power From Solar Alone, Ideal For Remote Locations Or Off-The-Grid Setups.
              </p>
              <div className="space-y-3">
                <h3 className="font-semibold" >
                  Key Features:
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    No Connection To The Public Grid Required
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Durable Design For Off-Grid Living Or Industrial Use
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Flexible System Size And Scalable Solutions
                  </li>
                </ul>
                <p className="mt-4 text-gray-700">
                  Best For: Remote Locations, Farms, And Off-Grid Commercial Applications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dealer & Distributor */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                Dealer & Distributor Pricing
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                We Offer Competitive Pricing For Both Dealers And Distributors, Ensuring Maximum Value On Every Unit Purchased.
              </p>
              <div className="space-y-3 mb-6">
                <h3 className="font-semibold" >
                  Inverter Pricing:
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    For Distributors: ₹[Insert Price] + GST Per Unit (Minimum 10 Units)
                  </li>
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    For Dealers: ₹[Insert Price] + GST Per Unit (Minimum 3 Units)
                  </li>
                </ul>
              </div>
              <div className="space-y-3 mb-6">
                <h3 className="font-semibold" >
                  Package Offers:
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <span className="mr-2" >•</span>
                    Complete Solar Combo: 720W Panels + 6kW Hybrid Inverter + ESS At Discounted Pricing For Dealers And Distributors.
                  </li>
                </ul>
              </div>
              <button
                className="text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors bg-brand-green"
                onClick={handleClick}
              >
                Talk To Our Sales Team
              </button>
            </div>
            <div className="">
              <img
                src="/white-solar-inverter-on-panel.png"
                alt="Solar Farm"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-brand-green">
                Why Choose Our Solar Panels?
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Kyra Green Energy Solution Is More Than A Distributor — We’re Your Partner In Clean Energy.
              </p>
              <ul className="space-y-4 text-gray-700">
                {[
                  "Trusted Brands: Fujiyama, Eastman, And Addos Solar",
                  "Exclusive 720W High-Performance Panels",
                  "Panels Tested For Quality, Durability, And Efficiency",
                  "Suitable For Residential, Commercial, And Industrial Use",
                  "Backed By Warranty And After-Sales Service",
                ].map((text, i) => (
                  <li key={i} className="flex items-start">
                    <span className="mr-3 mt-1" >•</span>
                    <span>{text}</span>
                  </li>
                ))}
              </ul>
              <button
                className="mt-8 text-white px-8 py-3 rounded-lg font-semibold hover:opacity-90 transition-colors bg-brand-green"
                onClick={handleClick}
              >
                Get A Free Consultation
              </button>
            </div>
            <div className="">
              <img
                src="/red-hybrid-solar-inverter.png"
                alt="Solar Installation"
              />
            </div>
          </div>
        </div>
      </section>


      <Faq type="inverter" />

    </>
  );
};

export default SolarInverter;
